<script lang="ts">
	import { twMerge, type ClassNameValue } from "tailwind-merge";
	import Icon from "#lib/components/Icon.svelte";
	import { DEFAULT_EXIT_BUTTON_BORDER, DEFAULT_EXIT_BUTTON_FILL, DEFAULT_EXIT_BUTTON_ICON, type ExitButtonStyle } from "#lib/page.js";
	import Button from "#lib/ui/Button/index.js";

	interface Props {
		style: ExitButtonStyle;
		// onClose closes the tray at runtime. Omit it in the editor preview so the
		// button is unclickable like other build mode elements.
		onClose?: () => void;
		class?: ClassNameValue;
	}

	let { style, onClose, class: className }: Props = $props();
</script>

<Button data-action-name="stack-controller-close" data-action-title="Close" color="none" class={twMerge("absolute top-4 right-4 z-10 rounded-full border p-1.5", !onClose && "pointer-events-none cursor-default", className)} style={`background-color: ${style.color ?? DEFAULT_EXIT_BUTTON_FILL}; border-color: ${style.borderColor ?? DEFAULT_EXIT_BUTTON_BORDER};`} on:click={() => onClose?.()}>
	<Icon name="x-mark" style={`color: ${style.iconColor ?? DEFAULT_EXIT_BUTTON_ICON};`} />
	<span class="sr-only">Close</span>
</Button>
